module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h4', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Marken & Adressen")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('marken-select')], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('adressen-select')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/firmen",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-811835d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/firmen/editFirmen_2.vue
// module id = 333
// module chunks = 0